import { ChangeRequestPart as BasePart } from "@corca/tiptap";
import { ReactNodeViewRenderer } from "@tiptap/react";

import { ChangeRequestPartAfterView } from "./ChangeRequestPartAfter";
import { ChangeRequestPartBeforeView } from "./ChangeRequestPartBefore";
import { getChangeRequestPartKind } from "./helpers";

import type { NodeViewProps } from "@tiptap/react";

function ChangeRequestPartView(props: NodeViewProps) {
  const { node } = props;
  const kind = getChangeRequestPartKind(node);
  return kind === "before" ? (
    <ChangeRequestPartBeforeView />
  ) : (
    <ChangeRequestPartAfterView {...props} />
  );
}

export const ChangeRequestPart = BasePart.extend<{
  lineMenu: "none";
}>({
  addOptions() {
    return {
      ...this.parent?.(),
      lineMenu: "none" as const,
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(ChangeRequestPartView);
  },
});
